<template>
  <eg-b-modal
    id="essay-rename-modal"
    :title="$t('essays.editEssayName')"
    size="lg"
    centered
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center justify-content-end">
        <eg-b-button variant="secondary" @click="close">
          {{ $t("common.cancel") }}
        </eg-b-button>
        <eg-b-button
          class="ml-2"
          :disabled="name.length === 0 || loading"
          variant="info"
          @click="onSave"
        >
          {{ $t("common.save") }}
        </eg-b-button>
      </div>
    </template>

    <div>
      <eg-b-form-input
        v-model="name"
        :placeholder="$t('common.name')"
        type="text"
      ></eg-b-form-input>
    </div>
  </eg-b-modal>
</template>

<script>
import { updatesEssay } from "@/api";

export default {
  props: {
    essay: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      name: "",
      loading: false,
    };
  },

  methods: {
    async onSave() {
      if (this.name.length === 0) {
        this.$showToastError(this.$t("essays.essayNameEmpty"));

        return;
      }

      this.loading = true;
      try {
        await updatesEssay(this.essay.id, { name: this.name });

        this.loading = false;
        this.$showToastSuccess(this.$t("essays.essayNameUpdated"), {
          title: this.$t("common.success"),
        });
        this.$emit("updated");
        this.$bvModal.hide("essay-rename-modal");
      } catch (error) {
        this.loading = false;

        this.$showToastError(error?.response?.data?.error);
      }
    },

    onShow() {
      this.name = this.essay.name;
    },

    onHide() {
      this.$emit("hide");
    },
  },
};
</script>

<style lang="scss">
.btn.try-again {
  padding: 0;
  margin: 0;
  border: 0;
  vertical-align: baseline;
}
</style>
